import { createRouteRef } from '@backstage/frontend-plugin-api';

// Deployment and catalog environment are path segments on every page
// (/ims-control-panel/:deployment/:environment/:kind[/:id]), so links pin
// both dimensions.
export const rootRouteRef = createRouteRef();

export const entityDetailRouteRef = createRouteRef({
  params: ['deployment', 'environment', 'kind', 'id'],
});

export const auditEventRouteRef = createRouteRef({
  params: ['deployment', 'environment', 'eventId'],
});
